import { useMutation } from '@tanstack/react-query';
import { CUSTOMER_REQUESET_REGISTERATION } from '@/constants/API';
import { axios } from '@/lib/axios';
import { SignupProps } from '@/types/auth';

export const registerWithEmailAndPassword = async (payload: SignupProps) =>
  await axios.post(CUSTOMER_REQUESET_REGISTERATION, payload);

export const useRegisterMutation = () => useMutation(registerWithEmailAndPassword);
